var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.2656 8.23438C38.2422 9.21094 38.2422 10.7969 37.2656 11.7734L17.2656 31.7734C16.2891 32.75 14.7031 32.75 13.7266 31.7734L3.72656 21.7734C2.75 20.7969 2.75 19.2109 3.72656 18.2344C4.70312 17.2578 6.28906 17.2578 7.26562 18.2344L15.5 26.4609L33.7344 8.23438C34.7109 7.25781 36.2969 7.25781 37.2734 8.23438H37.2656Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.149f2f29088d4f22d0ece504eb979baf.svg";
export { ForwardRef as ReactComponent };